import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// import * as StoreService from '../../api/storeService';
import * as StampCardService from '../../api/stampCardService';
import * as LoyaltyRewardService from '../../api/loyaltyRewardsService';
// import * as MemberService from '../../api/memberService';
import * as MerchantService from '../../api/merchantService';

import useNavContext from '../../hooks/useNavContext';

import Spinner from '../../components/Spinner';
import ErrorDialog from '../../components/Dialogs/ErrorDialog';
import AddStampDialog from '../../components/Dialogs/AddStampDialog';
import AddStampSuccessDialog from '../../components/Dialogs/AddStampSuccessDialog';
import useStampCardContext from '../../hooks/useStampCardContext';
import useMerchantContext from '../../hooks/useMerchantContext';

interface RouteParams {
  contactlessCode: string;
  merchantId: string;
  stampCardId: string;
  status: string;
  msg: string;
}

/**
 * Merchant
 */
export default function RedeemContactlessScreen() {
  const { contactlessCode, merchantId, stampCardId, status, msg } =
    useParams<RouteParams>();
  const [isLoading, setIsLoading] = useState(true);
  const [launchAlertDialog, setLaunchAlertDialog] = useState(false);
  const [stampSuccessDialog, setStampSuccessDialog] = useState(false);
  const [launchAddStampDialog, setLaunchAddStampDialog] = useState(false);
  const [stampCard, setStampCard] = useState<StampCardService.StampCard | null>(
    null,
  );
  const mId = merchantId;
  const [errorMsg, setErrorMsg] = useState('');
  const [addedStamp, setAddedStamp] = useState(1);
  const [code, setCode] = useState(contactlessCode);
  const [milestoneThresholdList, setMilestoneThresholdList] = useState<
    number[]
  >([]);
  const nav = useNavContext();
  const selectedMerchant = useMerchantContext();

  const history = useHistory();
  const sc = useStampCardContext();

  useEffect(() => {
    const handleSuccessfulRedemption = async () => {
      selectedMerchant?.setMerchant({ merchantId: mId });
      // fetch stamp card details
      try {
        const resStampCard = await StampCardService.get(stampCardId);
        if (resStampCard) {
          setStampCard(resStampCard);
          const resMilestone = await LoyaltyRewardService.listMilestone(
            resStampCard.loyalty_campaign.id,
          );

          if (resMilestone && resMilestone.length > 0) {
            setMilestoneThresholdList(resMilestone.map((m) => m.threshold));
          }
        }
      } catch (e) {
        console.log('Error: Fetch Stampcard from contactless code redemption');
      }
      setIsLoading(false);
      setStampSuccessDialog(true);
      setCode('');
    };

    const handleFailStoreLimit = async () => {
      // fetch stamp card details based on Merchant Id
      try {
        const resStampCardList = await StampCardService.listByMerchantId(mId);
        if (
          resStampCardList &&
          resStampCardList.length > 0 &&
          resStampCardList[0].id
        ) {
          selectedMerchant?.setMerchant({ merchantId: mId });
          if (sc) {
            sc.setStampCard({
              selectedStampCardId: resStampCardList[0].id,
              selectedSlotNumber: resStampCardList[0].slotNumber,
              selectedStampCampaignId: resStampCardList[0].loyalty_campaign.id,
            });
          }
        }
        setIsLoading(false);
        setErrorMsg(
          `You've reached the max number of stamps you can collect from this location.`,
        );
        setLaunchAlertDialog(true);
        setCode('');
      } catch (e) {
        console.log(
          'Error: Fetch Stampcard from contactless code store limit exceed',
        );
        setIsLoading(false);
        setCode('');
      }
    };

    const handleFailOther = async () => {
      if (mId === '0') {
        // merchantId is 0, just show invalid dialog
        // check if user is member of any merchant
        try {
          const resMerchants =
            await MerchantService.listMerchantsByMembership();
          if (resMerchants.length > 0) {
            selectedMerchant?.setMerchant({ merchantId: resMerchants[0].id });
            if (sc) {
              const resStampCards = await StampCardService.listByMerchantId(
                resMerchants[0].id,
              );
              if (resStampCards.length > 0) {
                sc.setStampCard({
                  selectedStampCardId: resStampCards[0].id,
                  selectedSlotNumber: resStampCards[0].slotNumber,
                  selectedStampCampaignId: resStampCards[0].loyalty_campaign.id,
                });
              }
            }
            setIsLoading(false);
            setErrorMsg('QR code is no longer valid.');
            setLaunchAlertDialog(true);
            setCode('');
          } else {
            setIsLoading(false);
            setErrorMsg('QR code is no longer valid.');
            setLaunchAlertDialog(true);
            setCode('');
          }
        } catch (err) {
          console.log('e', err);
          setIsLoading(false);
          setErrorMsg('QR code is no longer valid.');
          setLaunchAlertDialog(true);
          setCode('');
        }
      } else {
        // fetch stamp card details based on Merchant Id
        const resStampCardList = await StampCardService.listByMerchantId(mId);
        if (
          resStampCardList &&
          resStampCardList.length > 0 &&
          resStampCardList[0].id
        ) {
          selectedMerchant?.setMerchant({ merchantId: mId });
          if (sc) {
            sc.setStampCard({
              selectedStampCardId: resStampCardList[0].id,
              selectedSlotNumber: resStampCardList[0].slotNumber,
              selectedStampCampaignId: resStampCardList[0].loyalty_campaign.id,
            });
          }
        }
        setIsLoading(false);
        setErrorMsg('QR code is no longer valid.');
        setLaunchAlertDialog(true);
        setCode('');
      }
    };

    // const redeem = async () => {
    //   if (subscribed) {
    //     try {
    //       const resStore = await StoreService.getStoreByContactlessCode(
    //         code.split('_')[0],
    //       );

    //       if (resStore.merchant.id) {
    //         setMId(resStore.merchant.id);
    //         selectedMerchant?.setMerchant({ merchantId: resStore.merchant.id });
    //         try {
    //           const resRedeem =
    //             await StampCardService.creditStampCardContactless(code);
    //           if (resRedeem) {
    //             const resMilestone = await LoyaltyRewardService.listMilestone(
    //               resRedeem.loyalty_campaign.id,
    //             );

    //             if (resMilestone && resMilestone.length > 0) {
    //               setMilestoneThresholdList(
    //                 resMilestone.map((m) => m.threshold),
    //               );
    //             }
    //             console.log('ResRedeem: ', resRedeem);
    //             setStampCard(resRedeem);
    //             setIsLoading(false);
    //             setStampSuccessDialog(true);
    //             setCode('');
    //           }
    //         } catch (e: any) {
    //           try {
    //             const resStampCardList =
    //               await StampCardService.listByMerchantId(resStore.merchant.id);
    //             if (
    //               resStampCardList &&
    //               resStampCardList.length > 0 &&
    //               resStampCardList[0].id
    //             ) {
    //               selectedMerchant?.setMerchant({
    //                 merchantId: resStore.merchant.id,
    //               });
    //               if (sc) {
    //                 sc.setStampCard({
    //                   selectedStampCardId: resStampCardList[0].id,
    //                   selectedSlotNumber: resStampCardList[0].slotNumber,
    //                   selectedStampCampaignId:
    //                     resStampCardList[0].loyalty_campaign.id,
    //                 });
    //               }

    //               if (e && e.data && e.data[0].detail) {
    //                 if (
    //                   e.data[0].detail === 'Stamp count exceeds store limit'
    //                 ) {
    //                   selectedMerchant?.setMerchant({
    //                     merchantId: resStore.merchant.id,
    //                   });
    //                   setErrorMsg(
    //                     `You've reached the max number of stamps you can collect from this location.`,
    //                   );
    //                 } else {
    //                   selectedMerchant?.setMerchant({
    //                     merchantId: resStore.merchant.id,
    //                   });
    //                   setErrorMsg(e.data[0].detail);
    //                   console.log(
    //                     'Error: Redeem Stamp from contactless code',
    //                     e,
    //                   );
    //                 }
    //                 setLaunchAlertDialog(true);
    //                 setCode('');
    //               }
    //             }
    //             setIsLoading(false);
    //           } catch (err) {
    //             // user have no stamp card with merchant or membership
    //             // add user as member
    //             try {
    //               selectedMerchant?.setMerchant({
    //                 merchantId: resStore.merchant.id,
    //               });
    //               const resMember = await MemberService.join(
    //                 resStore.merchant.id,
    //               );

    //               if (resMember) {
    //                 setTimeout(async () => {
    //                   const resStampCard =
    //                     await StampCardService.listByMerchantId(
    //                       resStore.merchant.id,
    //                     );

    //                   if (resStampCard && resStampCard.length > 0) {
    //                     sc?.setStampCard({
    //                       selectedStampCardId: resStampCard[0].id,
    //                       selectedSlotNumber: resStampCard[0].slotNumber,
    //                       selectedStampCampaignId:
    //                         resStampCard[0].loyalty_campaign.id,
    //                     });
    //                     setIsLoading(false);
    //                   } else {
    //                     sc?.setStampCard({
    //                       selectedStampCardId: '',
    //                       selectedSlotNumber: 0,
    //                       selectedStampCampaignId: '0',
    //                     });
    //                     setIsLoading(false);
    //                   }
    //                 }, 1500);
    //               }
    //               setIsLoading(false);
    //               setErrorMsg(
    //                 'You have been added as a member. Please try redeeming your stamp again.',
    //               );
    //               setLaunchAlertDialog(true);
    //               setCode('');
    //             } catch (err2) {
    //               setIsLoading(false);
    //               setErrorMsg(
    //                 'Unable to add you as a member. Please try again later.',
    //               );
    //               setLaunchAlertDialog(true);
    //               setCode('');
    //               console.log(
    //                 'Error: Add member when redeeming stamp from contactless code',
    //                 err2,
    //               );
    //             }
    //           }
    //         }
    //       }
    //     } catch (e) {
    //       // Error fetching store from contactless code
    //       // check if user is member of any merchant
    //       try {
    //         const resMerchants =
    //           await MerchantService.listMerchantsByMembership();
    //         if (resMerchants.length > 0) {
    //           selectedMerchant?.setMerchant({
    //             merchantId: resMerchants[0].id,
    //           });
    //           if (sc) {
    //             const resStampCards = await StampCardService.listByMerchantId(
    //               resMerchants[0].id,
    //             );
    //             if (resStampCards.length > 0) {
    //               sc.setStampCard({
    //                 selectedStampCardId: resStampCards[0].id,
    //                 selectedSlotNumber: resStampCards[0].slotNumber,
    //                 selectedStampCampaignId:
    //                   resStampCards[0].loyalty_campaign.id,
    //               });
    //             }
    //           }
    //           setIsLoading(false);
    //           setErrorMsg('QR code is no longer valid.');
    //           setLaunchAlertDialog(true);
    //           setCode('');
    //         } else {
    //           setIsLoading(false);
    //           setErrorMsg('QR code is no longer valid.');
    //           setLaunchAlertDialog(true);
    //           setCode('');
    //         }
    //       } catch (err) {
    //         console.log('e', e);
    //         setIsLoading(false);
    //         console.log('Error: Fetch Store from contactless code');
    //         setErrorMsg('QR code is no longer valid.');
    //         setLaunchAlertDialog(true);
    //         setCode('');
    //       }
    //     }
    //   }
    // };

    if (isLoading && code.length > 0) {
      if (status === 'success') {
        // handle success redemption from deeplink
        handleSuccessfulRedemption();
      } else {
        if (status === 'fail') {
          // handle failed redemption from deeplink
          if (msg === 'exceeds_store_limit') {
            // handle stamp exceeds store limit
            handleFailStoreLimit();
          } else {
            // handle other failed msg
            handleFailOther();
          }
        }
      }
    }

    return () => {
      setCode('');
      setIsLoading(false);
    };
  }, [isLoading, code, selectedMerchant, sc, mId, stampCardId, status, msg]);

  const handleClose = async (
    stampCardId: string,
    slotNumber: number,
    stampCampaignId: string,
    status: string,
  ) => {
    // check if stampcard completed, get new stampCard id
    if (status !== 'completed') {
      if (sc) {
        sc.setStampCard({
          selectedStampCardId: stampCardId,
          selectedSlotNumber: slotNumber,
          selectedStampCampaignId: stampCampaignId,
        });
      }
      setStampSuccessDialog(false);
      selectedMerchant?.setMerchant({ merchantId });
      nav?.setNav({ menuNav: 'home' });
      history.replace(`/merchant`);
      window.location.reload();
    } else {
      try {
        const resNewStampCard =
          await StampCardService.getStampCardByCampaignAndSlot(
            stampCampaignId,
            slotNumber,
          );

        if (resNewStampCard.id !== stampCardId) {
          if (sc) {
            sc.setStampCard({
              selectedStampCardId: resNewStampCard.id,
              selectedSlotNumber: resNewStampCard.slotNumber,
              selectedStampCampaignId: resNewStampCard.loyalty_campaign.id,
            });
          }
          setStampSuccessDialog(false);
          nav?.setNav({ menuNav: 'home' });
          history.replace(`/merchant`);
          window.location.reload();
        } else {
          if (sc) {
            sc.setStampCard({
              selectedStampCardId: stampCardId,
              selectedSlotNumber: slotNumber,
              selectedStampCampaignId: stampCampaignId,
            });
          }
          setStampSuccessDialog(false);
          nav?.setNav({ menuNav: 'home' });
          history.replace(`/merchant`);
          window.location.reload();
        }
      } catch (e) {
        console.log('Error: Fetch Stampcard from merchant');
        if (sc) {
          sc.setStampCard({
            selectedStampCardId: stampCardId,
            selectedSlotNumber: slotNumber,
            selectedStampCampaignId: stampCampaignId,
          });
        }
        setStampSuccessDialog(false);
        nav?.setNav({ menuNav: 'home' });
        history.replace(`/merchant`);
        window.location.reload();
      }
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 200,
      }}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {mId && (
            <>
              <ErrorDialog
                open={launchAlertDialog}
                onClose={() => {
                  setLaunchAlertDialog(false);
                  history.replace(mId ? `/merchant` : '/');
                  window.location.reload();
                }}
                onConfirm={() => {
                  setLaunchAlertDialog(false);
                  history.replace(mId ? `/merchant` : '/');
                  window.location.reload();
                }}
                title="Error"
                body={errorMsg}
                confirmButtonText="OK"
              />
              {stampCard && mId && (
                <>
                  <AddStampDialog
                    stampCardId={stampCard.id}
                    open={launchAddStampDialog}
                    onClose={() => {
                      setLaunchAddStampDialog(false);
                      selectedMerchant?.setMerchant({ merchantId: mId });
                      nav?.setNav({ menuNav: 'home' });
                      history.replace(`/merchant`);
                      window.location.reload();
                    }}
                    confirmRedeem={(addedStamp: number) => {
                      setAddedStamp(addedStamp);
                      setLaunchAddStampDialog(false);
                      setStampSuccessDialog(true);
                    }}
                  />
                  <AddStampSuccessDialog
                    isComplete={stampCard.quantity === stampCard.redemptionCost}
                    isMilestone={
                      milestoneThresholdList.length > 0
                        ? milestoneThresholdList.includes(stampCard.quantity)
                        : false
                    }
                    open={stampSuccessDialog}
                    onClose={() => {
                      handleClose(
                        stampCard.id,
                        stampCard.slotNumber,
                        stampCard.loyalty_campaign.id,
                        stampCard.status,
                      );
                    }}
                    campaignId={stampCard.loyalty_campaign.id}
                    quantity={stampCard.quantity}
                    isMultipleStamp={addedStamp > 1}
                    stampAdded={addedStamp.toString()}
                    allowAddMoreStamp={true}
                    handleAddMoreStamp={() => {
                      if (sc) {
                        sc.setStampCard({
                          selectedStampCardId: stampCard.id,
                          selectedSlotNumber: stampCard.slotNumber,
                          selectedStampCampaignId:
                            stampCard.loyalty_campaign.id,
                        });
                      }
                      selectedMerchant?.setMerchant({ merchantId });
                      setStampSuccessDialog(false);
                      setLaunchAddStampDialog(true);
                    }}
                  />
                </>
              )}
            </>
          )}
          {!mId && (
            <ErrorDialog
              open={launchAlertDialog}
              onClose={() => {
                setLaunchAlertDialog(false);
                selectedMerchant?.setMerchant({ merchantId: mId });
                nav?.setNav({ menuNav: 'home' });
                history.replace(mId ? `/merchant` : '/');
                window.location.reload();
              }}
              onConfirm={() => {
                setLaunchAlertDialog(false);
                selectedMerchant?.setMerchant({ merchantId: mId });
                nav?.setNav({ menuNav: 'home' });
                history.replace(mId ? `/merchant` : '/');
                window.location.reload();
              }}
              title="Error"
              body={errorMsg}
              confirmButtonText="OK"
            />
          )}
        </>
      )}
    </div>
  );
}
